
import React from 'react';

interface IconProps {
  size?: number;
}

const NodeJsIcon: React.FC<IconProps> = ({ size = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-.18 19.82c-3.24 0-5.94-2.61-5.94-5.82s2.7-5.82 5.94-5.82c1.65 0 3.15.66 4.23 1.74l-1.41 1.41c-.72-.69-1.68-1.11-2.82-1.11-2.07 0-3.75 1.68-3.75 3.75s1.68 3.75 3.75 3.75c1.47 0 2.76-.84 3.39-2.07h-3.39v-2.01h5.82c.06.33.09.66.09 1.02 0 3.42-2.31 5.85-5.88 5.85z" fill="#339933"/>
    </svg>
  );
};

export default NodeJsIcon;
